import common from './common'
import forms from './forms'

export default {
  common,
  forms,
}
